import { render, staticRenderFns } from "./Odeme.vue?vue&type=template&id=65f6bc47&scoped=true&"
import script from "./Odeme.vue?vue&type=script&lang=js&"
export * from "./Odeme.vue?vue&type=script&lang=js&"
import style0 from "./Odeme.vue?vue&type=style&index=0&id=65f6bc47&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f6bc47",
  null
  
)

export default component.exports